import { Button, Dialog } from '@buffer-mono/popcorn'

const ConfirmRemoveChannelAccessModal = ({
  onConfirm,
  close,
  isOpen,
  data,
}: {
  onConfirm: () => void
  close: () => void
  isOpen: boolean
  data?: { channelName: string; email: string }
}): JSX.Element => {
  function handleSubmit(): void {
    onConfirm()
    close()
  }

  return (
    <Dialog modal open={isOpen}>
      <Dialog.Content>
        <Dialog.Header>
          <Dialog.Title>Are you sure?</Dialog.Title>
        </Dialog.Header>
        <Dialog.Body>
          <Dialog.Description>
            You are about to remove <strong>{data?.email}</strong>&apos;s access
            to <strong>{data?.channelName}</strong>. Are you sure you want to
            continue?
          </Dialog.Description>
        </Dialog.Body>
        <Dialog.Footer>
          <Button variant="tertiary" size="large" onClick={close}>
            Cancel
          </Button>

          <Button variant="primary" size="large" onClick={handleSubmit}>
            Yes, Remove
          </Button>
        </Dialog.Footer>
      </Dialog.Content>
    </Dialog>
  )
}

export default ConfirmRemoveChannelAccessModal
